// extracted by mini-css-extract-plugin
module.exports = {"container":"wishlistButton_container__fzZix"};